export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_00.8a163682.jpg";